import React from 'react';
import {
    List, Datagrid,
    TextField, DateField,
} from 'react-admin';
import { ColoredBooleanField } from '../../components/fields';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../styles/listStyles';

const RolesList = withStyles(styles)(({classes, ...props}) => (
    <List
        actions={null}
        perPage={25}
        bulkActions={false}
        sort={{
            field: 'Description',
            order: 'ASC'
        }}
        {...props}
    >
        <Datagrid
            rowClick='show'
        >
            <TextField
                source='Description'
            />
            <ColoredBooleanField
                source='Active'
                headerClassName={classes.active}
                cellClassName={classes.active}
            />
            <DateField
                source='CreateDate'
                headerClassName={classes.createDate}
                cellClassName={classes.createDate}
            />
            <DateField
                source='ModifiedDate'
                headerClassName={classes.modifiedDate}
                cellClassName={classes.modifiedDate}
            />
        </Datagrid>
    </List>
));
export default RolesList;